module.exports = __webpack_public_path__ + "e941e75363ed0dbe5d8839d412c98d56.svg";